module.exports = __webpack_public_path__ + "img/skating002.3da83ed4.jpg";